<script>
import { Line, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins
export default {
  extends: Line,

  mixins: [ reactiveProp ],

  props: {
    chartData: {
      type: Object,
      default: null
    },
    styles: {
      type: Object
    },
    options: {
      type: Object,
      default: () => ({
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }],
            xAxes: [ {
              gridLines: {
                display: true
              }
            }]
          },
          legend: {
            display: false
          },
          responsive: true,
          maintainAspectRatio: false
        })
    },
  },

  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>